import { groupBy } from 'lodash'
import { useMemo } from 'react'
import { useNavigate, useMatch } from 'react-router-dom'
import {
  DelimitedArrayParam,
  QueryParamConfig,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'

import { useMarketplace } from './useMarketplace'

const queryParamsConfig: Record<string, QueryParamConfig<any, any>> = {
  categories: withDefault(DelimitedArrayParam, []),
  deliveryZone: StringParam,
}

export const useCategories = () => {
  const marketplace = useMarketplace()
  const [categoryNames, setCategoryNames] = useQueryParams(queryParamsConfig)
  const navigate = useNavigate()
  const isOutletListRoute = useMatch(
    `/:merchantCategory(${marketplace.urlPath})`
  )

  const setCategoryNamesAndRedirectIfNotOutletList = ({
    categories,
  }: {
    categories: string[]
  }) => {
    setCategoryNames({ categories: categories.length ? categories : undefined })

    if (isOutletListRoute) {
      navigate(`${marketplace.urlPath}${location.search}`, {
        replace: true,
      })
    }
  }

  const topCategories = marketplace.categories.filter(
    ({ id }) => id === 'deals' || id === 'featured'
  )

  const allCategories = marketplace.categories.filter(
    ({ id }) => id !== 'deals' && id !== 'featured'
  )

  const categoriesByFirstLetter = groupBy(allCategories, category =>
    category.name.slice(0, 1)
  )

  const selectedCategories = useMemo(() => {
    return marketplace.categories.filter(({ name }) =>
      categoryNames.categories.includes(name)
    )
  }, [categoryNames, marketplace])

  return {
    topCategories,
    categoriesByFirstLetter,
    selectedCategories,
    setCategoryNames: setCategoryNamesAndRedirectIfNotOutletList,
  }
}
